import { Component, Input, OnInit } from '@angular/core';
import { ShareModel } from 'src/app/models/share.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';

@Component({
  selector: 'ipm-share-beat',
  templateUrl: './share-beat.component.html',
  styleUrls: ['./share-beat.component.scss']
})
export class ShareBeatComponent implements OnInit {
  @Input() shareData: ShareModel;
  constructor(private commonService: CommonService ,
    public browserStorageService : BrowserStorageService ,
    public ga4Tracking: Ga4trackingService, 
  ) {}
  ngOnInit(): void {
  }

  closeDialog() {
    this.commonService.closePopUp();
  }

  copyInputMessage(inputElement:any) {
    inputElement.select();
    const currentRoles = this.browserStorageService.getCurrentRoles();
    
    let eventname = this.shareData.type === 'beat' ? 'share_beat' : this.shareData.type === 'artist' ? 'share_artist' : this.shareData.type;
    let attributes: any = {
      category: 'Beats',
      label: 'button',
      action: 'click',
      userRole: this.browserStorageService?.getCurrentRoles() || currentRoles || 'guest',
      userId : this.browserStorageService?.getUserId() || 'guest'
     
    };
    this.ga4Tracking.sendEvent(eventname, attributes);


    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.commonService.closePopUp();
    this.commonService.showToastSuccess('Link copied to clipboard.');
  }
}
